import { BasePlugin } from '../base'
import mdcSnackbar from './mdc-snackbar.vue'

export { mdcSnackbar }

export default BasePlugin({
  mdcSnackbar
})
